
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const SystemsAssessmentSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  const systems = [
    { name: "systemsAssessment.mouthTongue", label: "child-patient-assessment.mouth-tongue", desc: "systemsAssessment.mouthTongueDescription" },
    { name: "systemsAssessment.respiratory", label: "child-patient-assessment.respiratory", desc: "systemsAssessment.respiratoryDescription" },
    { name: "systemsAssessment.genitourinary", label: "child-patient-assessment.genitourinary", desc: "systemsAssessment.genitourinaryDescription" },
    { name: "systemsAssessment.gastrointestinal", label: "child-patient-assessment.gastrointestinal", desc: "systemsAssessment.gastrointestinalDescription" },
    { name: "systemsAssessment.neurological", label: "child-patient-assessment.neurological", desc: "systemsAssessment.neurologicalDescription" },
    { name: "systemsAssessment.skin", label: "child-patient-assessment.skin", desc: "systemsAssessment.skinDescription" },
  ];

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <Grid container spacing={2}>
        {systems.map((sys) => (
          <Grid key={sys.name} md={2} xs={6}>
            <ByzTitleAndInputBox marginLeft="0px" title={t(sys.label)}>
              <Controller
                name={sys.name}
                control={control}
                render={({ field }) => (
                  <ByzMuiSelect {...field} options={[]} label={t("open-process-menu.select", "capitalize")} sx={{ pt: 1 }} />
                )}
              />
              <ByzTitleAndInputBox marginLeft="0px" sx={{ marginTop: "8px" }} title={t("description", "capitalize")}>
                <Controller
                  name={sys.desc}
                  control={control}
                  render={({ field }) => (
                    <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
                  )}
                />
              </ByzTitleAndInputBox>
            </ByzTitleAndInputBox>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
